/** Levenshtein distance — counts only, never stores the strings. */
export function editDistance(a: string, b: string): number {
  const left = String(a || '')
  const right = String(b || '')
  const n = left.length
  const m = right.length
  if (n === 0) return m
  if (m === 0) return n
  const prev = new Array<number>(m + 1)
  const cur = new Array<number>(m + 1)
  for (let j = 0; j <= m; j += 1) prev[j] = j
  for (let i = 1; i <= n; i += 1) {
    cur[0] = i
    for (let j = 1; j <= m; j += 1) {
      const cost = left[i - 1] === right[j - 1] ? 0 : 1
      cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost)
    }
    for (let j = 0; j <= m; j += 1) prev[j] = cur[j]
  }
  return prev[m]
}
